module.exports = "<router-outlet></router-outlet>\n<!-- <button name=\"addToHome\" id=\"addToHome\" (click)=\"addToHome()\">\n  Add to home\n</button> -->\n"